import { ADVANCE_DECLINE_VIEW_ALL, ADVANCE_DECLINE_VIEW_ALL_ERROR, ADVANCE_DECLINE_VIEW_ALL_HIDE_ERROR, ADVANCE_DECLINE_VIEW_ALL_START_LOADER, ADVANCE_DECLINE_VIEW_ALL_STOP_LOADER, ADVANCE_DECLINE_VIEW_ALL_STREAM, ADVANCE_DECLINE_VIEW_ALL_QUOTE_STREAM, } from "../interface/iAdvanceDeclineViewAll";
import { advDeclineQuoteStreamingUpdated, advDeclineStreamingUpdated, } from "@domains/features/Markets/Equity/utils/streamingUpdate";
const initState = {
    data: [],
    loader: true,
    errorData: {
        error: null,
        isOpen: false,
    },
    updatedtime: "",
};
const advanceDeclineViewAll = (state = initState, action) => {
    switch (action.type) {
        case ADVANCE_DECLINE_VIEW_ALL:
            return Object.assign(Object.assign({}, state), { data: action.payload.data, updatedtime: action.payload.updatedTime });
        case ADVANCE_DECLINE_VIEW_ALL_STREAM:
            return Object.assign(Object.assign({}, state), { data: advDeclineStreamingUpdated(state.data, action.payload.advDecStream), updatedtime: action.payload.advDecStream.lut });
        case ADVANCE_DECLINE_VIEW_ALL_QUOTE_STREAM:
            return Object.assign(Object.assign({}, state), { data: advDeclineQuoteStreamingUpdated(state.data, action.payload.quoteStream), updatedtime: action.payload.quoteStream.updatedTime });
        case ADVANCE_DECLINE_VIEW_ALL_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: action.payload.errorData });
        case ADVANCE_DECLINE_VIEW_ALL_HIDE_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: initState.errorData });
        case ADVANCE_DECLINE_VIEW_ALL_START_LOADER:
            return Object.assign(Object.assign({}, state), { loader: true });
        case ADVANCE_DECLINE_VIEW_ALL_STOP_LOADER:
            return Object.assign(Object.assign({}, state), { loader: false });
        default:
            return Object.assign({}, state);
    }
};
export default advanceDeclineViewAll;
